import Sy_Search from "./sy-search";

export default Sy_Search